<template lang="pug">
grid-container.w-100(gap="8px", cols="auto", auto-rows="max-content")
  custom-title(type="section", :text="title")
  communication-card.white--text.mb-1(
    v-for="({ title, scheduled, to }, i) in items",
    :key="i",
    :title="title",
    :date="scheduled",
    :to="to",
    max-width="100%"
  )
</template>

<script>
import CommunicationCard from "@/components/cards/Communication";
import CustomTitle from "@/components/others/CustomTitle";
import { formatToURL } from "@/components/utils.js";

const _config = {
  mod: "communications",
  title: "Últimos Comunicados",
  path: "/novidades/comunicados",
  itemsPerPage: 5,
};

export default {
  data: () => ({
    title: _config.title,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, title, scheduled }) => ({
        title,
        scheduled,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get({
      params: { itemsPerPage: _config.itemsPerPage },
      keepCache: true,
    });
  },
  components: {
    CustomTitle,
    CommunicationCard,
  },
};
</script>

<style></style>
